import React from 'react';

import styles from '../../WordpressPages.scss';

type EmptyContentProps = {
  message: string;
};

export const EmptyContent: React.FC<EmptyContentProps> = ({ message }) => (
  <div className={styles.empty}>
    {message}
  </div>
);
